import { render, staticRenderFns } from "./VAssetGroupForm.vue?vue&type=template&id=5d36dba8&"
import script from "./VAssetGroupForm.vue?vue&type=script&lang=js&"
export * from "./VAssetGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports